import React, { useState } from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    TextField,
    Typography,
    CircularProgress
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
//import axios from 'axios';
import nwLogo from '../assets/images/Infinium.png';
import splashImage from '../assets/images/infiniumsplash.png';
import axiosInstance from '../services/axiosInstance';
import appTitleImage from '../assets/images/qtitle.svg';



const ResetPasswordPage = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!newPassword || !confirmPassword) {
            setError('Both password fields are required.');
            return;
        }
        if (newPassword !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        setError('');
        setSuccess('');
        setLoading(true); 

        try {
            await axiosInstance.post(`/admin/reset-password`, {
                token,
                newPassword
            });

            setSuccess('Password reset successfully! Redirecting...');
            setNewPassword('');
            setConfirmPassword('');

            setTimeout(() => {
                navigate('/login');
            }, 500);
        } catch (err) {
            setError('Password reset failed. Please try again.');
        }
    };

    return (
        <Box position="relative" height="100vh" overflow="hidden">
            {/* Logo */}
            <Box sx={{ position: 'absolute', top: 15, left: 15, zIndex: 10 }}>
                <a href="https://infinium.consulting/" target="_blank" rel="noopener noreferrer">
                    <img
                        src={nwLogo}
                        alt="Infinium Logo"
                        style={{ height: '60px', objectFit: 'contain' }}
                    />
                </a>
            </Box>

            {/* Full Background Image */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                }}
            >
                <img
                    src={splashImage}
                    alt="splash"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        display: 'block'
                    }}
                />
            </Box>

            {/* Reset Password Form - Upper Left */}
            <Box
                sx={{
                    position: 'absolute',
                    top: '15%',
                    left: '8%',
                    zIndex: 5,
                }}
            >
                <Card sx={{ p: 4, borderRadius: 4, boxShadow: 8, width: 380 }}>
                    <CardContent>
                        <Typography variant="h4" fontWeight="bold" gutterBottom>
                            Set a New Password
                        </Typography>
                        <Typography color="text.secondary" variant="body2" gutterBottom>
                            Enter your new password and confirm to continue.
                        </Typography>

                        <form onSubmit={handleSubmit}>
                            <TextField
                                label="New Password"
                                type="password"
                                fullWidth
                                margin="normal"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                autoComplete="new-password"
                                InputLabelProps={{ shrink: true }}
                                required
                            />
                            <TextField
                                label="Confirm Password"
                                type="password"
                                fullWidth
                                margin="normal"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                autoComplete="new-password"
                                InputLabelProps={{ shrink: true }}
                                required
                            />

                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                                sx={{ mt: 2 }}
                                disabled={loading || !!success}
                            >
                                {loading ? <CircularProgress size={24} color="inherit" /> : 'Confirm'}
                            </Button>
                        </form>

                        {error && (
                            <Typography color="error" variant="body2" mt={2}>
                                {error}
                            </Typography>
                        )}
                        {success && (
                            <Typography color="primary" variant="body2" mt={2}>
                                {success}
                            </Typography>
                        )}
                    </CardContent>
                </Card>
            </Box>
            {/* App Title Image */}
            <Box sx={{ mt: 3, textAlign: 'center', width: 380 }}>
                <img
                    src={appTitleImage}
                    alt="App Title"
                    style={{ width: '100%', objectFit: 'contain' }}
                />
            </Box>
        </Box>
    );
};

export default ResetPasswordPage;
